<template>
    <v-container fluid fill-height>
        <v-layout v-if="pageLoading" align-center justify-center>
            <v-progress-circular indeterminate></v-progress-circular>
        </v-layout>

        <v-layout v-else column>
            <v-flex v-if="pageError != null" xs12>
                <v-alert outline type="error" :value="true">
                    {{pageError}}
                </v-alert>
            </v-flex>
            <v-card v-else>
                <v-form v-model="valid">
                    <v-toolbar color="primary" class="white--text">
                        <v-toolbar-title>Batch Edit End Date</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon large dark>grain</v-icon>
                    </v-toolbar>
                    
                    <v-layout class="dialog-content" align-center justify-center>
                        <v-flex xs12 md9 lg6>
                            <v-card-text v-if="invalidCrops.length == 0">
                                <v-alert type="info" outlined :value="true">
                                    When batch editing end dates the updated date will also apply to any crop attributes that exist on the selected crops.
                                </v-alert>
                                <date-picker ref="endDate"
                                    label="End Date"
                                    :value="endDate"
                                    @input="updateEndDate"
                                    :rules="[required]">
                                </date-picker>

                                <v-alert type="error" outlined :value="error != null">
                                    {{ error }}
                                </v-alert>
                            </v-card-text>
                            <v-card-text v-else>
                                <v-alert type="error" outlined :value="true">
                                    There are missing mandatory attributes on the crops listed below. Please edit these crops individually to add the missing attributes before performing a batch end date edit.
                                    <ul>
                                        <li v-for="crop in invalidCrops" :key="crop.CropID">{{ crop.CropCode }}
                                            <ul>
                                                <li v-for="error in crop.ErrorMessages" :key="error">
                                                    {{ error }}
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </v-alert>
                            </v-card-text>
                            <v-card-actions>
                                <v-layout row align-center justify-center>
                                    <v-flex xs12 md9 lg6>
                                        <v-layout row>
                                            <v-flex xs4 pa-2>
                                                <v-btn color="error" block @click="handleCancel">Cancel</v-btn>
                                            </v-flex>
                                            <v-flex xs4 pa-2>
                                                <v-btn color="primary" block :disabled="!canSave" @click="bulkSave" :loading="loading">Save</v-btn>
                                            </v-flex>               
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                    </v-flex>
                </v-layout>
                </v-form>
            </v-card>
        </v-layout>
    </v-container>
</template>


<script>
import cropApi from '@/api/cropApi';
import DatePicker from '@/components/generic/DatePicker.vue';
import UtilService from '@/services/utilService.js';

export default {
    components: {
        DatePicker
    },
    data() {
        return {
            pageLoading: false,
            pageError: null,
            cropData: [],
            endDate: new Date(),
            valid: false,
            loading: false,
            error: null
        };
    },
    computed: {
        invalidCrops() {
            return this.cropData.filter(crop => !crop.Valid);
        },
        canSave() {
            return this.invalidCrops.length == 0 && this.valid;
        }
    },
    methods: {
        async init() {
            this.pageLoading = true;
            this.error = null;
            try {
                let cropIDs = this.$route.params.cropIDs;
                this.cropData = await cropApi.batchGetCropEndDateEditData(cropIDs);
            } catch (e) {
                this.error = 'Failed to load crop data: ' + e.message;
            } finally {
                this.pageLoading = false;
            }
        },
        async bulkSave() {
            this.loading = true;
            this.error = null;
            try {
                let cropIDs = this.$route.params.cropIDs.split(',');
                var response = await cropApi.batchSaveCropEndDateEditData({
                    CropIDs: cropIDs,
                    EndDate: UtilService.formatDateYMD(this.endDate)
                });

                if (response.Success) {
                    await this.handleCancel();
                } else {
                    this.error = response.ErrorMessages.join(' ');
                }
            } catch (e) {
                this.error = 'Failed to save crop end dates: ' + e.message;
            } finally {
                this.loading = false;
            }
        },
        updateEndDate(v){
            this.endDate = v;
        },
        async handleCancel() {
            try {
                parent.CloseRadWindow();
            } catch (error) {
                this.error = error;
            }
        },
    },
    created() {
        this.init();
    }
}
</script>